const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "outline/question-template"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.7679 1.25L14 1.25C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L20.5303 7.46967C20.671 7.61032 20.75 7.80109 20.75 8V17.2321C20.75 18.045 20.75 18.7006 20.7066 19.2315C20.662 19.7781 20.5676 20.2582 20.3413 20.7025C19.9818 21.4081 19.4081 21.9817 18.7025 22.3413C18.2582 22.5676 17.7781 22.662 17.2315 22.7066C16.7006 22.75 16.045 22.75 15.2321 22.75H8.76788C7.95505 22.75 7.29944 22.75 6.76853 22.7066C6.2219 22.662 5.74175 22.5676 5.29754 22.3413C4.59193 21.9817 4.01825 21.4081 3.65873 20.7025C3.43239 20.2582 3.33803 19.7781 3.29336 19.2315C3.24999 18.7006 3.24999 18.0449 3.25 17.2321V6.7679C3.24999 5.95506 3.24999 5.29944 3.29336 4.76853C3.33803 4.2219 3.43239 3.74175 3.65873 3.29754C4.01825 2.59193 4.59193 2.01825 5.29754 1.65873C5.74175 1.43239 6.2219 1.33803 6.76853 1.29336C7.29944 1.24999 7.95506 1.24999 8.7679 1.25ZM6.89068 2.78838C6.4368 2.82547 6.17604 2.8946 5.97852 2.99524C5.55516 3.21095 5.21095 3.55516 4.99524 3.97852C4.8946 4.17604 4.82547 4.4368 4.78838 4.89068C4.75058 5.35331 4.75 5.94755 4.75 6.8V17.2C4.75 18.0525 4.75058 18.6467 4.78838 19.1093C4.82547 19.5632 4.8946 19.824 4.99524 20.0215C5.21095 20.4448 5.55516 20.789 5.97852 21.0048C6.17604 21.1054 6.4368 21.1745 6.89068 21.2116C7.35331 21.2494 7.94755 21.25 8.8 21.25H15.2C16.0525 21.25 16.6467 21.2494 17.1093 21.2116C17.5632 21.1745 17.824 21.1054 18.0215 21.0048C18.4448 20.789 18.789 20.4448 19.0048 20.0215C19.1054 19.824 19.1745 19.5632 19.2116 19.1093C19.2494 18.6467 19.25 18.0525 19.25 17.2V8.75007L15.5738 8.75007C15.3163 8.75009 15.0798 8.75011 14.8821 8.73396C14.669 8.71654 14.4358 8.67668 14.2055 8.55933C13.8762 8.39155 13.6085 8.12384 13.4407 7.79456C13.3234 7.56425 13.2835 7.33108 13.2661 7.11794C13.25 6.92026 13.25 6.68379 13.25 6.42631L13.25 2.75H8.8C7.94755 2.75 7.35331 2.75058 6.89068 2.78838ZM14.75 3.81066L18.1894 7.25007H15.6C15.3076 7.25007 15.1334 7.24949 15.0043 7.23894C14.9255 7.2325 14.8923 7.224 14.8835 7.22125C14.8388 7.19773 14.8023 7.16125 14.7788 7.11661C14.7761 7.10773 14.7676 7.0746 14.7611 6.9958C14.7506 6.86667 14.75 6.69247 14.75 6.40007V3.81066ZM14.7797 7.1192C14.7797 7.11923 14.7795 7.11876 14.7792 7.11768L14.7797 7.1192ZM14.8809 7.22034C14.8809 7.22033 14.8814 7.22051 14.8824 7.22091L14.8809 7.22034Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 9 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.25 15.25H11.75V19.75H8C7.0335 19.75 6.25 18.9665 6.25 18V15.25ZM7.75 16.75V18C7.75 18.1381 7.86193 18.25 8 18.25H10.25V16.75H7.75Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 11 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.25 11C6.25 10.0335 7.0335 9.25 8 9.25H11.75V13.75H6.25V11ZM8 10.75C7.86193 10.75 7.75 10.8619 7.75 11V12.25H10.25V10.75H8Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 13 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.25 12.25H11.75V16.75H6.25V12.25ZM7.75 13.75V15.25H10.25V13.75H7.75Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 10 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.25 15.25H17.75V18C17.75 18.9665 16.9665 19.75 16 19.75H10.25V15.25ZM11.75 16.75V18.25H16C16.1381 18.25 16.25 18.1381 16.25 18V16.75H11.75Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 12 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.25 9.25H16C16.9665 9.25 17.75 10.0335 17.75 11V13.75H10.25V9.25ZM11.75 10.75V12.25H16.25V11C16.25 10.8619 16.1381 10.75 16 10.75H11.75Z",
  fill: "#6B8FBC"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle 14 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.25 12.25H17.75V16.75H10.25V12.25ZM11.75 13.75V15.25H16.25V13.75H11.75Z",
  fill: "#6B8FBC"
}));

const SvgQuestionTemplate = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionTemplate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question-template.207ab5a4.svg";
export { ForwardRef as ReactComponent };